module.exports = __webpack_public_path__ + "static/media/logoCampos.bac5842c.png";